// Color de identidad del módulo Caja Viático — mismo patrón que las otras Cajas.
export const CAJA_VIATICO_COLOR = "#00695c";
